import api from './api';
import { ENDPOINTS } from './endpoints';

// Content services
export const contentService = {
  getList: (params) => api.get(ENDPOINTS.CONTENT.LIST, { params }),
  getDetail: (id) => api.get(ENDPOINTS.CONTENT.DETAIL(id)),
  search: (query) => api.get(ENDPOINTS.CONTENT.SEARCH, { params: { query } }),
};

// Category services
export const categoryService = {
  getList: () => api.get(ENDPOINTS.CATEGORIES.LIST),
  getDetail: (id) => api.get(ENDPOINTS.CATEGORIES.DETAIL(id)),
};

// Comment services
export const commentService = {
  getList: (contentId) => api.get(ENDPOINTS.COMMENTS.LIST(contentId)),
  add: (contentId, comment) => api.post(ENDPOINTS.COMMENTS.ADD(contentId), comment),
};

// Blog services
export const blogService = {
  getProminent: () => api.get(ENDPOINTS.BLOGS.PROMINENT),
  getBySlug: (slug) => api.get(`/blogs?slug=${slug}`),
};

// Game review services
export const gameReviewService = {
  getRecently: () => api.get(ENDPOINTS.GAME_REVIEWS.RECENTLY),
  getLatest: () => api.get(ENDPOINTS.GAME_REVIEWS.LATEST),
  getBySlug: (slug) => api.get(`/game-reviews?slug=${slug}`),
  getPopular: () => api.get('/game-reviews/popular'),
  getPopularNow: () => api.get('/game-reviews/popular-now'),
};

// App review services
export const appReviewService = {
  getRecently: () => api.get(ENDPOINTS.APP_REVIEWS.RECENTLY),
  getLatest: () => api.get(ENDPOINTS.APP_REVIEWS.LATEST),
  getBySlug: (slug) => api.get(`/app-reviews?slug=${slug}`),
  getPopular: () => api.get('/app-reviews/popular'),
  getPopularNow: () => api.get('/app-reviews/popular-now'),
};

// Image service
export const imageService = {
  getThumbnail: (path) => ENDPOINTS.IMAGES.THUMBNAIL(path),
};

// Export api instance and endpoints for direct use if needed
export { api, ENDPOINTS }; 